// modules/initMetricsSpotlight.js

/**
 * Spotlight sequenziale per sezioni .metrics-section
 *
 * - Attiva una sola riga alla volta (opacity 1 → resto 0.25)
 * - Loop continuo
 * - Rispetta prefers-reduced-motion (se attivo, tutto visibile e stop)
 *
 * Attributi data supportati sul <section>:
 * - data-cycle="2" → durata per item in secondi (default 2)
 * 
 */

export function initMetricsSpotlight() {
    const sections = document.querySelectorAll('.metrics-section');
    if (!sections.length) {
        console.warn('[MetricsSpotlight] Nessuna sezione trovata.');
        return;
    }

    console.log(`[MetricsSpotlight] Trovate ${sections.length} sezioni.`);

    // Verificas se prefers-reduced-motion è attivo
    const prefersReduced =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach((section, i) => {
        const items = section.querySelectorAll('.metrics-item');
        if (!items.length) {
            console.warn(`[MetricsSpotlight] Nessuna .metrics-item in sezione #${i}.`);
            return;
        }

        console.log(
            `[MetricsSpotlight] Sezione #${i} → ${items.length} items`
        );

        if (prefersReduced) {
            items.forEach((el) => el.classList.add('is-active'));
            console.log(`[MetricsSpotlight] prefers-reduced-motion: tutto attivo.`);
            return;
        }

        const cycle =
            parseFloat(section.getAttribute('data-cycle')) || 2.0; // sec per item
        let index = 0;
        let timer = null;

        function activate(i) {
            items.forEach((el, j) => {
                el.classList.toggle('is-active', j === i);
            });
            //console.log(`[MetricsSpotlight] Sezione #${i} → attivo item ${i + 1}`);
        }

        function start() {
            if (timer) clearInterval(timer);
            activate(index);
            timer = setInterval(() => {
                index = (index + 1) % items.length;
                activate(index);
            }, cycle * 1000);
        }

        // Nel caso ci sia un item
        if (items.length === 1) {
            activate(0);
            return;
        }

        start();
    });
}
